let modulesCache = {};

window.require = (moduleName) => {
  // The automatic JSX runtime (jsx: 'react-jsx') imports from 'react/jsx-runtime'.
  // It isn't exposed on the UMD global, so reconstruct it from window.React.createElement.
  const jsxRuntime = () => {
    const React = window['React'];
    if (!React) return null;
    const jsx = (type, props, key) =>
      React.createElement(type, key === undefined ? props : Object.assign({}, props, { key }));
    return { jsx, jsxs: jsx, jsxDEV: jsx, Fragment: React.Fragment };
  };

  let shims = {
    'react': () => window['React'],
    'react-dom': () => window['ReactDOM'],
    'react/jsx-runtime': jsxRuntime,
    'react/jsx-dev-runtime': jsxRuntime,
    'lodash': () => window['lodash'] || window['_'],
  }

  if(modulesCache[moduleName]) {
    return modulesCache[moduleName];
  }

  const requestedModuleFunc = shims[moduleName];
  if(requestedModuleFunc) {
    let module = requestedModuleFunc();
    if(module) {
      console.log("%cUsing 'window."+moduleName+"'", 'color: green;')
      modulesCache[moduleName] = module;
      return module;
    } else {
      console.log("%c'window."+moduleName+"' has to be loaded and available in the window where this bundle was loaded", 'font-size: 18px;color: red;')
      throw new Error(`Could not load window replacement for module: ${moduleName}`);
    }
  } else {
    throw new Error(`Could not resolve module: ${moduleName}`);
  }
};
